import type { PropsWithChildren } from 'react';
import { useStoreState } from '../store';
import { NewVersionAvailableModal } from './components/NewVersionAvailableModal';
import { titleFromSlug } from './utils';
import { HeaderBar } from './components/HeaderBar';
import { BreadCrumbs } from './components/BreadCrumbs';
import { CommonLayout } from './CommonLayout';

export const ConfigLayout = ({ children, flexibleWidth = false }: PropsWithChildren<{ flexibleWidth?: boolean }>) => {
  const title = useStoreState((state) => state.navigation.pageTitle) || titleFromSlug();
  const pageLoading = useStoreState((state) => state.loading.pageLoading === true);

  return (
    <CommonLayout
      flexibleWidth={flexibleWidth}
      title={title}
      pageLoading={pageLoading}
      header={
        <HeaderBar>
          <BreadCrumbs
            omitCrumbList={[
              { key: 'configure', index: 0 },
              // route "/{sessionPartnerUrl}/carrier-selection" does not exist
              { key: 'carrier-selection' },
            ]}
          />
        </HeaderBar>
      }
    >
      {children}
      <NewVersionAvailableModal />
    </CommonLayout>
  );
};
